
export const SERVER_URL            =    "https://deh-vand.ir/"//*/        "http://localhost:4000/"
export const PWA_DEHVAND_APP_URL   =    "https://web.deh-vand.ir/"//*/    "http://web.localhost:4000/" 
export const arrSocialNetwork=[
       {
              id:1 , 
              name:'اینستاگرام' , 
              icon:require("../assets/images/socialNetwork/instagram.png")
       } , 
       {
              id:2 , 
              name:'واتس آپ' , 
              icon:require("../assets/images/socialNetwork/whatsapp.png")
       } , 
       {
              id:3 , 
              name:'تلگرام' , 
              icon:require("../assets/images/socialNetwork/telegram.png")
       } , 
       {
              id:4 , 
              name:'روبیکا' , 
              icon:require("../assets/images/socialNetwork/robika.png")
       } , 
       {
              id:5 , 
              name:'ایتا' , 
              icon:require("../assets/images/socialNetwork/eitaa.png")
       } , 
       {
              id:6 , 
              name:'بله' , 
              icon:require("../assets/images/socialNetwork/bale.png")
       } , 
       {
              id:7 , 
              name:'سروش' , 
              icon:require("../assets/images/socialNetwork/sorush.png")
       } 
]
export const REQUEST_FOR_ANDROID=false